/* Etiquetas multiidoma en castellano. */
export default {
  "viewWrapper.language.english": "English",
  "viewWrapper.language.spanish": "Español",
  "viewWrapper.menu.bookingSearch": "Mis reservas",
  "viewWrapper.menu.liquidation": "Informe de ventas",
  "viewWrapper.menu.logout": "Salir",
  "viewWrapper.menu.searcher": "Buscador",
};
